import { getRuntimeConfig } from './runtimeConfig'

/**
 * Instanz-Schalter "Demnaechst verfuegbar" (config.json `comingSoon`, TQ #1023): true, wenn der
 * Bereich in dieser Instanz nur den Hinweis zeigen soll. Ohne Eintrag: false, Verhalten unveraendert.
 */
export function isComingSoon(area: string): boolean {
  return (getRuntimeConfig().comingSoon ?? []).includes(area)
}
